// Ana sayfadaki teaser kartında gösterilecek "öne çıkan" beat'ler.
//
// Ses dosyaları artık repo'da değil (Cloudflare R2'de), o yüzden burada
// elle mp3 yolu tutmuyoruz — sadece hangi beat'lerin öne çıkacağını
// başlıklarıyla seçiyoruz, gerisini generated manifest veriyor.

import { beatsItems as allBeats } from "./beats.generated";

const FEATURED_TITLES = [
    "140 Bpm D Min (Decap)",
    "122 Bpm D# Min (Kentucky Drippin)",
    "182 Bpm A Min (Fam Business)",
];

const picked = FEATURED_TITLES
    .map((title) => allBeats.find((b) => b.title === title))
    .filter(Boolean);

// Seçilenlerden biri katalogdan kalkmışsa açık kalmasın, baştan doldur.
export const beatsItems = picked.length === FEATURED_TITLES.length
    ? picked
    : [...picked, ...allBeats.filter((b) => !picked.includes(b))].slice(0, FEATURED_TITLES.length);
